var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"light"},on:{"click":_vm.openLink}},[_vm._v("\n  Connect a Bank Account with\n  "),_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/Plaid_(company)-Logo.wine.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }